import { Title, Container, Main } from '../../components'
import styles from './styles.module.css'
import MetaTags from 'react-meta-tags'

const About = ({ updateOrders, orders }) => {
  
  return <Main>
    <MetaTags>
      <title>О проекте</title>
      <meta name="description" content="Foodgram - сервис публикации рецептов: избранное, корзина покупок, подписки, короткие ссылки." />
      <meta property="og:title" content="О проекте" />
    </MetaTags>
    
    <Container>
      <h1 className={styles.title}>О проекте</h1>
      <div className={styles.content}>
        <div>
          <h2 className={styles.subtitle}>Что это за проект?</h2>
          <div className={styles.text}>
            <p className={styles.textItem}>
              <strong>Foodgram</strong> — это полноценный продукт по публикации и просмотру рецептов: пользователи создают
              рецепты с ингредиентами, тегами и временем приготовления, добавляют их в избранное и
              корзину покупок, подписываются на авторов и делятся короткими ссылками на рецепты.
            </p>
            <p className={styles.textItem}>
              Реализован как демонстрационный проект: SPA-фронтенд на React, REST API на Django REST Framework,
              PostgreSQL как база данных, токенная авторизация, развёрнут на подпути
              <a href="https://atsaev-dev.ru/foodgram" className={styles.textLink}> atsaev-dev.ru/foodgram </a>
              в единой экосистеме с остальными проектами.
            </p>
            <p className={styles.textItem}>
              Отдельно продумана производительность и корректность работы под путём: фронт собран с базовым
              путём <code>/foodgram/</code>, API, медиафайлы и короткие ссылки не «утекают» из подпути,
              контент доступен без ошибок.
            </p>
            <p className={styles.textItem}>
              Демо-доступы для знакомства с проектом указаны в плашке сайта: можно войти как обычный
              пользователь или как модератор в админку.
            </p>
          </div>
        </div>
        <aside>
          <h2 className={styles.additionalTitle}>Ссылки</h2>
          <div className={styles.text}>
            <p className={styles.textItem}>
              Репозиторий проекта:{' '}
              <a href="https://github.com/Atsaev/foodgram" className={styles.textLink} rel="noreferrer" target="_blank">github.com/Atsaev/foodgram</a>
            </p>
            <p className={styles.textItem}>
              Автор:{' '}
              <a href="https://atsaev-dev.ru" className={styles.textLink} rel="noreferrer" target="_blank">Ацаев Хасан</a>
            </p>
            <p className={styles.textItem}>
              Основной сайт-портфолио:{' '}
              <a href="https://atsaev-dev.ru" className={styles.textLink} rel="noreferrer" target="_blank">atsaev-dev.ru</a>
            </p>
          </div>
        </aside>
      </div>
    </Container>
  </Main>
}

export default About

